var viewer_default = {
  "gallery_container": "aBxYH",
  "imageTitleContainer": "r12id",
  "clickableItem": "Pqt1j",
  "prerender": "wpTS7",
  "expandButton": "TNrbO",
  "itemContainer": "TlMvp",
  "expandIcon": "Jfvn1",
  "itemOverlay": "jtdz2",
  "imageTitle": "EYvBt",
  "pointer": "GC862",
  "fadeIn": "ISjKI",
  "changing_background": "iEITx"
};
export {
  viewer_default as default
};
//# sourceMappingURL=viewer-scss.js.map
